import * as React from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import heroStyles, { heroStylesSmall } from "../Styling/HeroAreaStyling";
import { SimpleBreadcrumbs } from "./SimpleBreadcrumbs";

interface IHeroArea {
    imageUri: string;
    title: string;
    subtitle: string;
    variant?: HeroAreaVariant;
}

export type HeroAreaVariant = "default" | "small";

const HeroAreaSmall: React.FC<IHeroArea> = ({ imageUri, title, subtitle }) => {
    const classes = heroStylesSmall(imageUri)();

    return (
        <section className={classes.heroContent}>
            <div className={classes.blackOverlay}></div>

            <Container
                style={{ margin: "50 50", position: "relative" }}
                maxWidth="lg"
            >
                <Grid
                    justify="flex-start"
                    alignItems="center"
                    container
                    spacing={3}
                >
                    <Grid item>
                        <SimpleBreadcrumbs></SimpleBreadcrumbs>
                        <Typography
                            variant="h1"
                            gutterBottom
                            className={classes.title}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            paragraph
                            className={classes.text}
                        >
                            {subtitle}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

const HeroArea: React.FC<IHeroArea> = props => {
    const classes = heroStyles(props.imageUri)();

    if (props.variant) {
        if (props.variant === "small") {
            return <HeroAreaSmall {...props} />;
        }
    }

    return (
        <section className={classes.heroContent}>
            <div className={classes.blackOverlay}></div>

            <Container
                style={{ margin: "50 50", position: "relative" }}
                maxWidth="lg"
            >
                <Grid
                    justify="flex-start"
                    alignItems="center"
                    container
                    spacing={3}
                >
                    <Grid item>
                        <SimpleBreadcrumbs></SimpleBreadcrumbs>
                        <Typography
                            variant="h1"
                            gutterBottom
                            className={classes.title}
                        >
                            {props.title}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            paragraph
                            className={classes.text}
                        >
                            {props.subtitle}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default HeroArea;
